// Price section minimum height, to prevent layout shifting while loading price or don't have price.
export const PRICE_MIN_HEIGHT = 96;
export const COMPARISON_PRICE_MIN_HEIGHT = 68;
